import {css, StyleSheet} from 'aphrodite';
import React, {useEffect} from 'react';

import {trackEvent} from 'analytics/Analytics';
import {BLAST_ANALYTICS_ACTIONS} from 'constants/analytics-products';
import Button, {ButtonSize, ButtonStyle} from 'ui-library/buttons/Button';

interface AlignmentCompareButtonProps {
  numSelected: number;
  comparing: boolean;
  setComparing: (comparing: boolean) => void;
}

export default function AlignmentCompareButton(props: AlignmentCompareButtonProps): JSX.Element {
  const text = props.comparing ? 'Back' : `Compare ${props.numSelected} results`;

  useEffect(
    () => () => {
      props.setComparing(false);
    },
    /* eslint-disable-next-line react-hooks/exhaustive-deps */
    []
  );

  return (
    <Button
      text={text}
      className={css(styles.button)}
      size={ButtonSize.SMALL}
      buttonStyle={ButtonStyle.TERTIARY_GRAY}
      onClick={() => {
        if (!props.comparing) {
          trackEvent(BLAST_ANALYTICS_ACTIONS.CLICKED_COMPARE_RESULTS_BUTTON, {
            selectedItemsCount: props.numSelected,
          });
        }
        props.setComparing(!props.comparing);
      }}
    />
  );
}

export const styles = StyleSheet.create({
  button: {
    boxShadow: 'none',
    marginLeft: '8px',
  },
});
